import React from 'react';
import { ProjectionVariant } from 'src/api/types';
import { NoData, Poppins, Tooltip } from 'src/common';
import styled from 'styled-components';

const Div = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 8px;

  .dot {
    width: 13px;
    height: 13px;
    border-radius: 50%;
    &--base {
      background: ${({ theme }) => theme.colors.prussianBlue};
    }
    &--live {
      background: ${({ theme }) => theme.colors.gp1};
    }
    &--complete {
      background: ${({ theme }) => theme.colors.brightBlue};
    }
  }

  span {
    line-height: 90%;
  }
`;

type GenFrequencyLabel = (params: {
  scenario?: {
    frequency_times?: number | null;
    frequency_years?: number | null;
  };
  variant?: ProjectionVariant;
  tooltipText?: string;
  /** Append " (N% chance per year)" — round(times/years*100), clamped 0-100. */
  showChancePercent?: boolean;
}) => JSX.Element;

export const genFrequencyLabel: GenFrequencyLabel = ({ scenario, variant, tooltipText = '', showChancePercent }) => {
  const times = scenario?.frequency_times;
  const years = scenario?.frequency_years;
  const hasValues = !!times && !!years;

  const chanceSuffix =
    showChancePercent && hasValues
      ? ` (${Math.min(100, Math.max(0, Math.round((times! / years!) * 100)))}% chance per year)`
      : '';

  return (
    <Tooltip dataHtml={tooltipText} dataId="f-base" place="top">
      <Div>
        {variant && <div className={`dot dot--${variant}`} />}
        <Poppins px={14} weight={500} css="display: flex; align-items: center">
          {!hasValues ? (
            <>
              <div style={{ marginRight: '5px' }}>
                <NoData iconOnly techIncomplete />
              </div>
              {`${times || '-'} time(s) per ${years || '-'} year(s)`}
            </>
          ) : (
            <Poppins px={14} weight={500} data-cy="scenario-frequency">{`${times} time(s) per ${years} year(s)${chanceSuffix}`}</Poppins>
          )}
        </Poppins>
      </Div>
    </Tooltip>
  );
};
